import { ActivatedRouteSnapshot } from "@angular/router";

export class ActivatedRouteParamsResolutionError extends Error {
  constructor(public activatedRouteSnapshot: ActivatedRouteSnapshot) {
    super("ActivatedRouteParamsResolutionError");
  }
}
